import {
  SHOWCASE_STATUS_AGREEMENT,
  SHOWCASE_STATUS_DRAFT,
  SHOWCASE_STATUS_PUBLISHED,
  SHOWCASE_STATUS_REJECTED,
  SHOWCASE_STATUS_REMOVED,
  SHOWCASE_STATUS_REVISION,
  SHOWCASE_STATUS_ID_AGREEMENT,
  SHOWCASE_STATUS_ID_DRAFT,
  SHOWCASE_STATUS_ID_PUBLISHED,
  SHOWCASE_STATUS_ID_REJECTED,
  SHOWCASE_STATUS_ID_REMOVED,
  SHOWCASE_STATUS_ID_REVISION,
} from '@/api/models/ProjectShowcaseStatus';

const getShowcaseVisibleStatusForAdmin = (statusId, publicStatusId = null) => {
  switch (statusId) {
    case SHOWCASE_STATUS_ID_DRAFT:
      return {
        type: SHOWCASE_STATUS_DRAFT,
        text: 'Черновик',
        actionLabel: 'Публикацию проекта необходимо отправить на согласование',
        description:
          'Вам пока ничего не нужно делать. ' +
          'Руководитель проекта скоро отправит этот проект на согласование для публикации на витрине.',
      };
    case SHOWCASE_STATUS_ID_AGREEMENT:
      return {
        type: SHOWCASE_STATUS_AGREEMENT,
        text: 'На согласовании',
        actionLabel: 'Требуется согласовать публикацию проекта на витрине',
        description:
          'Руководитель проекта хочет опубликовать этот проект на витрине. Проект будет опубликован только после ' +
          'Вашего согласования. Согласуйте публикацию проекта на витрине, нажав на кнопку ниже, ' +
          'или отклоните публикацию проекта, если Вы против или имеются корректировки к описанию проекта.',
      };
    case SHOWCASE_STATUS_ID_PUBLISHED:
      return {
        type: SHOWCASE_STATUS_PUBLISHED,
        text: 'Согласовано',
        actionLabel: 'Вы согласовали публикацию проекта на витрине',
        description:
          'Вы согласовали публикацию проекта на витрине. ' +
          'Если Вы изменили решение или у Вас появились корректировки к описанию проекта, ' +
          'Вы можете снять с публикации проект в любое время. ',
      };
    case SHOWCASE_STATUS_ID_REJECTED:
      if (publicStatusId === SHOWCASE_STATUS_ID_PUBLISHED) {
        return {
          type: SHOWCASE_STATUS_REVISION,
          text: 'Отклонено',
          actionLabel: 'Вы отклонили публикацию изменений',
          description:
            'Вы отклонили публикацию изменений информации о проекте, но предыдущая версия проекта по прежнему опубликована. ' +
            'Вы можете снять с публикации проект в любое время. ',
        };
      } else {
        return {
          type: SHOWCASE_STATUS_REJECTED,
          text: 'Отклонено',
          actionLabel: 'Вы отклонили публикацию проекта',
          description:
            'Вы отклонили публикацию проекта. Если требуется опубликовать проект на витрине, нажмите на кнопку ниже.',
        };
      }
    case SHOWCASE_STATUS_ID_REMOVED:
      return {
        type: SHOWCASE_STATUS_REMOVED,
        text: 'Отозвано',
        actionLabel: 'Вы сняли проект с публикации',
        description:
          'Вы сняли проект с публикации. Если требуется вернуть проект на витрину, нажмите на кнопку ниже.',
      };
    case SHOWCASE_STATUS_ID_REVISION:
      return {
        type: SHOWCASE_STATUS_REVISION,
        text: 'Обновление',
        actionLabel: 'Публикация обновляется',
        description:
          'Руководитель проекта обновляет данные в публикации. ' +
          'После внесения новых данных он отправит публикацию на согласование. ' +
          'Вы можете снять с публикации проект в любое время. ',
      };
    default:
      return {
        type: 'undefined',
        text: 'Undefined',
        actionLabel: 'Undefined',
        description: 'Undefined status',
      };
  }
};

export { getShowcaseVisibleStatusForAdmin };
